// extracted by mini-css-extract-plugin
export default {"description":"PnftInfo_description__tl6Vr"};